var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "22px",
    viewBox: "0 0 29 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "by-photos",
    transform: "translate(-63.000000, -869.000000)",
    fill: "#302745",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81,869 C81.4304304,869 81.8125693,869.27543 81.9486833,869.683772 L82.7207592,872 L90,872 C91.1045695,872 92,872.895431 92,874 L92,889 C92,890.104569 91.1045695,891 90,891 L65,891 C63.8954305,891 63,890.104569 63,889 L63,874 C63,872.895431 63.8954305,872 65,872 L72.2792408,872 L73.0513167,869.683772 C73.1874307,869.27543 73.5695696,869 74,869 L81,869 Z M80.2792408,871 L74.7207592,871 L73.9486833,873.316228 C73.8125693,873.72457 73.4304304,874 73,874 L65,874 L65,889 L90,889 L90,874 L82,874 C81.5695696,874 81.1874307,873.72457 81.0513167,873.316228 L80.2792408,871 Z M77.5,876 C80.5375661,876 83,878.462434 83,881.5 C83,884.537566 80.5375661,887 77.5,887 C74.4624339,887 72,884.537566 72,881.5 C72,878.462434 74.4624339,876 77.5,876 Z M77.5,878 C75.5670034,878 74,879.567003 74,881.5 C74,883.432997 75.5670034,885 77.5,885 C79.4329966,885 81,883.432997 81,881.5 C81,879.567003 79.4329966,878 77.5,878 Z M87,876 C87.5522847,876 88,876.447715 88,877 C88,877.552285 87.5522847,878 87,878 L85,878 C84.4477153,878 84,877.552285 84,877 C84,876.447715 84.4477153,876 85,876 L87,876 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.f5a86967.svg";
export { ForwardRef as ReactComponent };